const mobile_toggle = document.querySelector('.js-navigation-toggle');
if (mobile_toggle) {
	const mobile_navigation = document.querySelector('.js-mobile-navigation');
	mobile_toggle.addEventListener('click', () => {
		mobile_toggle.classList.toggle('active');
		mobile_navigation.classList.toggle('active');
	});
}
